const fieldsToRemove = ['width', 'height', 'id']

export const processScImage = (fieldValue, size) => {
  if (!fieldValue) return null

  const sizesToRemove = Object.keys(fieldValue).filter(item => item.includes('cloudinary'))
  const toRemove = [...fieldsToRemove, ...Object.values(sizesToRemove)]
  const sizeKey = sizesToRemove.find(item => item.includes(size))
  const src = fieldValue[sizeKey] || fieldValue.src
  const value = { ...fieldValue, src }

  toRemove.forEach(item => delete value[item])

  return value
}
